import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const scriptParams = document.currentScript.dataset;

ReactDOM.render(
  <React.StrictMode>
    <App scriptParams={{...scriptParams}} />
  </React.StrictMode>,
  document.getElementById('coin-telekom-suchschlitz')
);
